const activity = {
  activity: "Activiteit", // translated
  activities: "Activiteiten", // translated
  dates: "data", // translated
  location: "Plaats", // translated
  languages: "Talen", // translated
  categories: "Categorieën", // translated
  ticketOption: "Ticket optie", // translated
  numberOfRatings: "Aantal beoordelingen", // translated
  meetingPointInfo: "Informatie over ontmoetingspunt", // translated
  meetingPoint: "Ontmoetingspunt", // translated
  meetingPoints: "Ontmoetingspunten", // translated
  providedBy: "Geleverd door", // translated
  expirationDate: "Uiterste houdbaarheidsdatum", // translated
  groupSize: "Groepsgrootte", // translated
  features: "Functies", // translated
  basedOn: "Gebaseerd op", // translated
  reviewsFromVerCustomers: "beoordelingen van geverifieerde klanten", // translated
  excellent: "uitstekend", // translated
  great: "Geweldig", // translated
  average: "gemiddeld", // translated
  poor: "arm", // translated
  bad: "slecht", // translated
  onlyBookedCustomersTooltip: "Alleen klanten die deze activiteit geboekt hebben, kunnen een beoordeling achterlaten", // translated
  noReviewsYet: "Op dit moment zijn er geen beoordelingen voor deze activiteit.", // translated
  backToActivitiesList: "Terug naar activiteitenlijst", // translated
  getPrices: "prijzen krijgen", // translated
  availabilityAndPrices: "Beschikbaarheid en prijzen", // translated
  ticketOptions: "Ticketopties", // translated
  ticketInfo: "Ticketinformatie", // translated
  selectYourTickets: "Selecteer uw kaartjes", // translated
  product: "Product", // translated
  total: "Totaal", // translated
  slot: "Sleuf", // translated
  language: "Taal", // translated
  tickets: "Kaartjes", // translated
  ticketsFor: "Kaartjes voor", // translated
  previousStep: "Vorige stap", // translated
  onlyAvailableInEnglish: "Alleen beschikbaar in het Engels", // translated
  guest: "Gast", // translated
  leadGuest: "Hoofdgast", // translated
  adult: "Volwassen", // translated
  child: "Kind", // translated
  pleaseSelectAdult: "Selecteer minimaal één volwassene", // translated
  notAvailableActivity: "Dit product is niet beschikbaar", // translated
  required: "Vereist", // translated
  pickupPoint: "Ophaalpunt", // translated
  pickupPoints: "Ophaalpunten", // translated
  ticketType: "Tickettype", // translated
  anonymous: "Anoniem", // translated
  printedVoucher: "Gedrukte voucher geaccepteerd", // translated
  mobileVoucher: "Mobiele voucher geaccepteerd", // translated
  mixedVoucher: "Mobiele of gedrukte voucher geaccepteerd", // translated
  safetyMeasures: "Veiligheidsmaatregelen toegepast", // translated
  doThisBecause: "Doe dit omdat", // translated
  safetyInfo: "Veiligheidsinformatie", // translated
  reviewsHighestFirst: "Aantal beoordelingen (hoogste eerst)", // translated
  bookingFee: "Reserveringskosten", // translated
  startDate: "Begin datum", // translated
  endDate: "Einddatum", // translated
  cancellationDeadlineAndFees: "Annuleringstermijn en kosten", // translated
  resetTickets: "Tickets resetten", // translated
  instantConfirmation: "onmiddelijke bevestiging", // translated
  clickResetBtn: "Klik op de resetknop om uw selectie opnieuw te starten", // translated
};


export default activity;
